import { LeaderboardPage } from "lib/types/leaderboards";
import { omit } from "lodash";

const csvHeaders = {
  rank: "Rank",
  previousRank: "Previous Rank",
  companyName: "Company Name",
  sector: "Sector",
  description: "Description",
  website: "Website",
  hqCity: "HQ City",
  hqCountry: "HQ Country",
  employees: "Employees",
  foundedYear: "Founded Year",
  totalFunding: "Total Funding",
  latestRevenue: "Latest Revenue",
  latestFundraise: "Latest Fundraise",
  latestFundraiseDate: "Latest Fundraise Date",
  revenueCagr: "Revenue CAGR",
  profitable: "Profitable",
};

export const downloadCSV = (data: LeaderboardPage["list"]) => {
  const csvRows: string[][] = [];

  data
    .map((company) => omit(company, ["id", "updatedAt", "logo"]))
    .forEach((company) => {
      const row: string[] = [];
      for (const key of Object.keys(csvHeaders)) {
        if (key === 'hqCity' || key === 'hqCountry') {
          const val = String(company['location'])
            .replace(/"/g, "'")
            .split(",")[key === 'hqCity' ? 0 : 1];
          row.push(`"${val}"`);
        } else {
          const val = String(company[key] || "").replace(/"/g, "'");
          row.push(`"${val}"`);
        }
      }

      csvRows.push(row);
    });

  const csvContent = [Object.values(csvHeaders), ...csvRows].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${document.title.replace(/\s/g, "_")}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};